import axios from 'axios';
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { FaEye, FaUserLock } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import LoadingButton from '../components/LoadingButton';
import { useGStore } from '../context/Context';
import { FETCHING_ERROR, FETCHING_OF, FETCHING_START, FETCHING_SUCCESS_USER } from '../state/actionTypes/actionTypes';

const Login = () => {
    const {state , dispatch} = useGStore()
    const navigation = useNavigate();
    const [data , setData] = useState({});
    const [passShow,setPassShow] = useState(false)


    if(state?.user?.loginAccess){
       navigation("/")
    }

    const handleRegister = (e)=>{
        e.preventDefault();
           if(!data.number){
            return toast.error("মোবাইল নাম্বার পাওয়া যাইনি")
           }
           if(!data.pass){
            return toast.error("পাসওয়ার্ড নাম্বার পাওয়া যাইনি")
           }
       if(data?.pass?.length < 6 || data.pass === "undefined"){
        return toast.error("পাসওয়ার্ড ৬ টি সংখ্যা দিতে হবে")
       }
       if(data.pass || data.number){
        dispatch({type: FETCHING_START})
        axios.get(`https://amar-dish-server.vercel.app/users?number=${data.number}&pass=${data.pass}`).then(res=>{
            // console.log(res.data);
            if(res.data.message === "success"){
                dispatch({type : FETCHING_SUCCESS_USER , payload : res.data.user})
                localStorage.setItem("loginAccess",JSON.stringify({login :res.data.user.loginAccess,number : res.data.user.userNumber}))
                navigation("/");
                toast.success("লগইন সফল হয়ছে")
            }
            if(res.data.message === "not found"){
                toast.error("আপনার একাউন্টি পাওয়া যাইনি")
                 dispatch({type: FETCHING_OF})
            }
            if(res.data.message === "wrong password"){
                toast.error("পসওয়ার্ডটি সঠিক নয়")
                dispatch({type: FETCHING_OF})
            }
                
        }).catch(error =>{
            console.log(error);
            dispatch({type: FETCHING_ERROR})
        })
       }
    }
    // console.log(state);
    return (
       <div className='bg-blue-600'>
      
         <div className='h-[100vh] w-full flex items-center justify-center'>
            <div className='w-[360px] lg:w-96 h-[450px] shadow-2xl p-10 rounded-md bg-white'>
            <h1 className='text-4xl text-center my-2'>আমার বিল</h1>
            <div className='flex items-center justify-center gap-2'>
            <FaUserLock size={24}></FaUserLock>
            <h1 className="text-2xl font-bold my-4 text-center">লগইন</h1>
            </div>
            <form onSubmit={handleRegister} className='flex flex-col gap-4'>
            {/* <input type="name" placeholder="আপান" className="input input-bordered w-full " /> */}
            <input type="tel" onChange={(e)=>setData({...data,number : e.target.value})} placeholder="নাম্বার লিখুন" className="input input-bordered w-full " />
            {/* <input type="email" placeholder="Email" className="input input-bordered w-full " /> */}
            <div className='relative'>
        <input type={passShow  ?"text" :"password" } onChange={(e)=>setData({...data,pass : e.target.value})} placeholder="পাসওয়ার্ড" className="input input-bordered w-full " />
        <button type='button' onClick={()=>setPassShow(!passShow)} className='btn btn-ghost absolute right-0 top-0'><FaEye size={24}></FaEye></button>
        </div>
           {
            state.loading ?<LoadingButton text={"পাঠিয়ে দিন"}></LoadingButton> : <input type="submit" value={"পাঠিয়ে দিন"} className="btn btn-ghost w-full " />
           }   
            </form>
            <p className='text-sm text-center'>নতুন একাউন্ট খুলতে<Link className='btn btn-link p-1 text-blue-600' to="/register">রেজিস্ট্রেশন করুন</Link></p>
            </div>
        </div>
       </div>
    );
};

export default Login;